export class SocialNetworks{
  facebook:string;
  x:string;
  instagram:string;
  linkedin:string;
  tiktok:string;
  youtube:string;
}
